import React, { useEffect, useState } from "react";

const ScrollingBanner = () => {
  const [vw, setVw] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );

  useEffect(() => {
    const onResize = () => setVw(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const isMobile = vw < 1024;

  const TapanMessage = () => (
    <span className="scrolling-text" style={{ paddingRight: 50 }}>
      🚀 Dr. Tapan Sahoo of Maruti Suzuki India Limited joins Ravity's Board of Directors{"  "}
      <a
        href="https://www.linkedin.com/feed/update/urn:li:activity:7437392860947206145/"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "#010A71",
          textDecoration: "none",
          fontWeight: 600,
          marginLeft: 8,
        }}
      >
        Learn more →
      </a>
    </span>
  );


  const MarutiMessage = () => (
    <span className="scrolling-text" style={{ paddingRight: 50 }}>
      🚀 Maruti Suzuki invests Rs 2 Crore in Ravity{" "}
      <a
        href="/Press_Release_Maruti_Suzuki_invests_in_connected_mobility_intelligence_based_startup.pdf"
        target="_blank"
        rel="noopener noreferrer"
        className="click-here"
      >
        (Click here)
      </a>
    </span>
  );


  return (
    <div
      className="scrolling-banner"
      style={{
        backgroundColor: "#F00D69",
        color: "#FFFFFF",
        overflow: "hidden",
        width: "100%",
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 9999,
        fontWeight: 600,
        fontSize: isMobile ? 24 : 18,
        height: isMobile ? 64 : 50,
        lineHeight: isMobile ? "64px" : "50px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        className="scrolling-track"
        style={{
          display: "inline-flex",
          whiteSpace: "nowrap",
          animation: "scroll-left 35s linear infinite",
        }}
      >
        <TapanMessage />
        <MarutiMessage />
        <TapanMessage />
        <MarutiMessage />
        <TapanMessage />
        <MarutiMessage />
        <TapanMessage />
        <MarutiMessage />
      </div>
      <style>
        {`
          @keyframes scroll-left {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
             .click-here {
      color: #010A71;
      text-decoration: underline;
      cursor: pointer;
      padding: 2px 4px;
      border-radius: 4px;
    }

    .click-here:hover {
      background: linear-gradient(90deg, #FFCE4E 0%, #57D29F 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-decoration: none;
    }
        `}
      </style>
    </div>
  );
};

export default ScrollingBanner;

